<template>
  <footer class="flex-wrap text-left the-footer" :class="classes">
    <span></span>
    <span
      >© {{ new Date().getFullYear() }}
      <a href="https://classhub.ly/" target="_blank" rel="nofollow">ClassHub</a
      >، جميع الحقوق محفوظة.</span
    >
    <!--<span class="items-center hidden md:flex">-->
    <!--<span>Hand-crafted & Made with</span>-->
    <!--<feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="mr-2" />-->
    <!--</span>-->
  </footer>
</template>

<script>
export default {
  name: "the-footer",
  props: {
    classes: {
      type: String,
    },
  },
};
</script>
